import React, { useEffect } from 'react';
import { TippyTooltip } from './TippyTooltip.js';
import { PopupTooltip } from './PopupTooltip.js';
import warnDeprecation from '../../utils/warnDeprecation.js';
import '../../_rollupPluginBabelHelpers-c245b26a.js';
import '@indeed/ifl-css';
import '@tippyjs/react/headless';
import './Arrow.js';
import './plugins.js';
import '@emotion/react';
import '../../utils/transition.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../index-26fc6478.js';
import '../../utils/mergeRefs.js';
import 'use-debounce';
import '@indeed/ihl-use-id';
import '../Popup/Popup.js';
import '@floating-ui/react-dom';
import '../../hooks/useMergeRefs.js';
import '../Box/Box.js';
import '../Portal/Portal.js';
import 'react-dom';
import '../../utils/warn.js';

const popupTooltipAllowedProps = new Set(["alignment", "aria", "children", "delay", "label", "onHide", "onShow", "popupProps", "portaled", "side", "theme", "trigger", "visible"]);

/**
 * @see https://experience.indeed.design/components/ids/tooltip
 */
const Tooltip = props => {
  // Perform the set difference of props with popup allowed props
  const tippyTooltipProps = Object.keys(props).filter(p => !popupTooltipAllowedProps.has(p));
  useEffect(() => {
    if (Array.isArray(props.delay)) {
      warnDeprecation(`[Tooltip] In IFL 7.0, the \`delay\` prop will only accept a number, not an array of numbers. See https://link.indeed.tech/ifl-7-prep-guide for more information.`);
    }
    if (tippyTooltipProps.length > 0) {
      warnDeprecation(`[Tooltip] The following props to Tooltip are deprecated and will no longer be supported in IFL 7.0: ${tippyTooltipProps.join(", ")}. See https://link.indeed.tech/ifl-7-prep-guide for more information.`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let TooltipComp = PopupTooltip;
  if (tippyTooltipProps.length > 0 || Array.isArray(props.delay)) {
    TooltipComp = TippyTooltip;
  }
  return /*#__PURE__*/React.createElement(TooltipComp, props);
};
Tooltip.displayName = "Tooltip";

export { Tooltip };
